<template>
    <section class="app-container form">
        <!-- 表单 -->
        <el-form :model="form" ref="form" :inline="inline" :rules="formRules" :label-width="labelWidth" :label-position="labelPosition">
            <slot name="form-items" />
        </el-form>
        <div :style="btnPosition" class="btn-group">
            <slot name="form-btns"></slot>
            <el-button v-if="showSubmitBtn" class="add-details-btn" :loading="submitting" :disabled="submitting" @click="onSubmit">{{showSubmitBtnTxt}}</el-button>
            <el-button v-if="showResetBtn" class="add-edit-btn" @click="resetForm">重置</el-button>
            <el-button v-if="showGoBackBtn" class="add-back-btn" @click="goBack ? goBack() : goBacks()">返回</el-button>
        </div>
    </section>
</template>

<script>
import { scrollTo } from "@/utils/scroll-to";
export default {
    name: "art.edit",
    props: {
        // 参数管理处理
        isParmater: { type: Boolean, default: false },
        // 是否弹窗确认
        isPop: { type: Boolean, default: false },
        inline: { type: Boolean, default: false },
        showSubmitBtnTxt: { type: String, default: "提交" },
        // 表单
        form: { type: Object, default: Object },
        isDeepClone: { type: Boolean, default: false },
        // 表单验证
        formRules: { type: Object, default: Object },
        // label 宽
        labelWidth: { type: String, default: "100px" },
        // 提交请求方法
        submitFunc: { type: Function, default: () => {} },
        // 提交成功后方法
        submitSuccessFunc: { type: Function, default: () => {} },
        // 提交失败后方法
        submitErrorFunc: { type: Function, default: () => {} },
        // 是否自动重置表单
        isAutoResetForm: { type: Boolean, default: true },
        // 提交之前方法(如需要改变form, 返回新form)
        beforeSubmitFunc: { type: Function, default: (form) => form },
        // 重置表单之后的方法(一般用于清空图片)
        resetFormCallback: { type: Function, default: Function },
        // 是否需要重置表单
        isResetForm: { type: Boolean, default: true },
        // 展示提交按钮
        showSubmitBtn: { type: Boolean, default: true },
        // 展示重置按钮
        showResetBtn: { type: Boolean, default: true },
        // 展示返回按钮
        showGoBackBtn: { type: Boolean, default: true },
        // 表单样式
        formStyle: { type: String, default: "" },
        // label位置
        labelPosition: { type: String, default: "right" },
        //按钮样式
        btnPosition: { type: String, default: "margin-left:150px" },
        goBack: { type: Function },
    },
    data() {
        return {
            defaultForm: {},
            submitting: false,
        };
    },
    mounted() {
        // 保存到默认表单
        this.defaultForm = { ...this.form };
        this.defaultForm = JSON.parse(JSON.stringify(this.form))
    },
    methods: {
        /**
         * 提交表单
         * 先验证, 再提交
         */
        onSubmit() {
            let that = this;
            that.$refs.form.validate((valid, object) => {
                if (!valid) {
                    for (let i in object) {
                        if (document.getElementById(i)) {
                            let dom = document.getElementById(i);

                            let top = dom.offsetTop; //获取当前节点的偏移值
                            // let scrollTop = document.documentElement.scrollTop;　　//获取视图滚动值
                            // let diff = top + scrollTop;
                            scrollTo(top - 170, 400);
                        }
                        break;
                    }

                    return;
                }
                const form = this.beforeSubmitFunc(
                    that.isDeepClone
                        ? that.deepClone(that.form)
                        : { ...that.form },
                    that.$refs.form
                );
                if (!form) {
                    // form = { ...this.form }
                    return;
                }
                that.submitting = true;
                if (that.isPop) {
                    that.$confirm(
                        "注意！一旦确认提交该SPU信息将无法修改医院/项目/项目名称等信息，请核对清楚再提交！?",
                        "警告",
                        {
                            confirmButtonText: "确定",
                          confirmButtonClass:'confirmBtn',
                            cancelButtonText: "取消",
                            type: "warning",
                        }
                    )
                        .then(() => {
                            that.submitFunc(form)
                                .then((result) => {
                                    that.submitting = false;
                                    // this.$logger.success(result)
                                    //this.$message.success('提交成功')
                                    that.isAutoResetForm && that.resetForm();
                                    that.submitSuccessFunc(result);
                                    that.goBack
                                        ? that.goBack()
                                        : that.goBacks();
                                })
                                .catch((error) => {
                                    that.submitting = false;
                                    console.error(error);
                                    that.submitErrorFunc(error);
                                });
                        })
                        .catch(() => {
                            that.submitting = false;
                        });
                } else {
                    that.submitFunc(form)
                        .then((result) => {
                            that.submitting = false;
                            // this.$logger.success(result)
                            //this.$message.success('提交成功')

                            if (that.isParmater) {
                                that.submitSuccessFunc(result);
                                if (result) {
                                    that.isAutoResetForm && that.resetForm();
                                    that.goBack
                                        ? that.goBack()
                                        : that.goBacks();
                                }
                            } else {
                                that.isAutoResetForm && that.resetForm();
                                that.submitSuccessFunc(result);
                                that.goBack ? that.goBack() : that.goBacks();
                            }
                        })
                        .catch((error) => {
                            that.submitting = false;
                            console.error(error);
                            that.submitErrorFunc(error);
                        });
                }
            });
        },
        /**
         * 重置表单
         */
        resetForm() {

            if (this.isResetForm) {
                // this.defaultForm.status = 'Enable'
              ;
                this.$emit("update:form", this.defaultForm);
                this.$refs.form.resetFields();
            }
            this.resetFormCallback();
        },

        deepClone(initalObj) {
            const obj = {};
            if (typeof initalObj !== "object") {
                return initalObj;
            }
            for (const key in initalObj) {
                if (initalObj[key] === null) {
                    initalObj[key] = null;
                    continue;
                }
                if (typeof initalObj[key] === "object") {
                    if (Array.isArray(initalObj[key])) {
                        obj[key] = initalObj[key].map((item) =>
                            this.deepClone(item)
                        );
                    } else {
                        obj[key] = this.deepClone(initalObj[key]);
                    }
                } else if (typeof initalObj[key] === "function") {
                    obj[key] = initalObj[key].bind(obj);
                } else {
                    obj[key] = initalObj[key];
                }
            }
            return obj;
        },
        clearValidateTip() {
            this.$refs.form.clearValidate();
        },
        goBacks() {
            let refresh = localStorage.getItem("refresh") || void 0;
            if (refresh) {
                this.$router.back(-2);
                localStorage.setItem("refresh", "");
            } else this.$router.back();
        },
        validates() {
            let that = this;
            that.$refs.form.validate((valid, object) => {
                if (!valid) {
                    for (let i in object) {
                        if (document.getElementById(i)) {
                            let dom = document.getElementById(i);

                            let top = dom.offsetTop; //获取当前节点的偏移值
                            // let scrollTop = document.documentElement.scrollTop;　　//获取视图滚动值
                            // let diff = top + scrollTop;
                            scrollTo(top - 170, 400);
                        }
                        break;
                    }

                    return;
                }
                const form = this.beforeSubmitFunc(
                    that.isDeepClone
                        ? that.deepClone(that.form)
                        : { ...that.form },
                    that.$refs.form
                );
                if (!form) {
                    // form = { ...this.form }
                    return;
                }
                that.submitting = true;
                that.submitFunc(form)
                    .then((result) => {
                        that.submitting = false;
                        // this.$logger.success(result)
                        //this.$message.success('提交成功')
                        that.isAutoResetForm && that.resetForm();
                        that.submitSuccessFunc(result);
                        that.goBack ? that.goBack() : that.goBacks();
                    })
                    .catch((error) => {
                        that.submitting = false;
                        console.error(error);
                        that.submitErrorFunc(error);
                    });
            });
        },
    },
};
</script>

<style scoped>
.form {
    margin: 20px 0;
    padding-right: 30px;
    background: #fff;
    padding-bottom: 20px;
    border-radius: 8px;
    margin-top: 0;
}

.btn-group {
}
.btn-group .add-details-btn {
    width: 150px;
    height: 50px;
    background: #3572e2;
    border-radius: 2px;
    color: #fff;
    font-size: 16px;
    border-color: #3572e2;
}
.btn-group .add-edit-btn {
    width: 124px;
    height: 50px;
    border: 1px solid #e1e1e1;
    border-radius: 2px;
    background-color: #fff;
}
.btn-group .add-back-btn {
    width: 124px;
    height: 50px;
    border: 1px solid #e1e1e1;
    border-radius: 2px;
    background-color: #fff;
}
</style>
